import Link from "./Link";
import Default from "./Default";
import Text from "./Text";
import Iframe from "./Iframe";

export default {
  Link,
  Default,
  Text,
  Iframe
};
